module.exports = __webpack_public_path__ + "assets/sharepoint.a42809d7.svg";